import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">分类浏览</h2>
          <Link
            to="/category/dushi-yanqing"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat) => {
            const count = articles.filter((a) => a.category === cat.slug).length;
            const colorMap: Record<string, { bg: string; text: string; border: string; iconBg: string }> = {
              accent: {
                bg: 'hover:bg-accent-50',
                text: 'text-accent-700',
                border: 'border-accent-200',
                iconBg: 'bg-accent-100',
              },
              primary: {
                bg: 'hover:bg-primary-50',
                text: 'text-primary-700',
                border: 'border-primary-200',
                iconBg: 'bg-primary-100',
              },
              secondary: {
                bg: 'hover:bg-secondary-50',
                text: 'text-secondary-700',
                border: 'border-secondary-200',
                iconBg: 'bg-secondary-100',
              },
            };
            const colors = colorMap[cat.color] || colorMap.primary;

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex items-center gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70 ${colors.bg} transition-all duration-300 cursor-pointer`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${colors.iconBg} ${colors.text} flex-shrink-0`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{cat.description}</p>
                  <span className="text-xs text-foreground-400 mt-1 inline-block">{count} 篇作品</span>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors duration-200"></i>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}